import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { MarketingShell } from "../components/MarketingShell";
import { getContactEmail, getPublicSiteOrigin } from "../api/client";

const FEEDBACK_FORM_URL = "https://tally.so/r/RGLN7v";

export default function ContactPage() {
  const origin = getPublicSiteOrigin() || "https://setpilot.org";
  const url = `${origin}/contact`;
  const title = "Contact — SetPilot";
  const description = "Reach the SetPilot team by email or feedback form for support, partnerships, and privacy questions.";
  const email = getContactEmail();

  return (
    <MarketingShell>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={url} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
      </Helmet>

      <article className="m-prose">
        <h1>Contact</h1>
        <p className="m-lede">
          We read every message. For product feedback, bugs, or partnerships, use email or the short form below.
        </p>

        <h2>Email</h2>
        <p>
          <a href={`mailto:${email}`}>{email}</a>
        </p>

        <h2>Feedback form</h2>
        <p>
          Prefer a structured form?{" "}
          <a href={FEEDBACK_FORM_URL} target="_blank" rel="noopener noreferrer">
            Open the SetPilot feedback form
          </a>{" "}
          (opens in a new tab).
        </p>

        <h2>Privacy &amp; legal</h2>
        <p>
          For privacy-specific requests, email us with &quot;Privacy&quot; in the subject. You can also read our{" "}
          <Link to="/privacy-policy">privacy policy</Link> and <Link to="/terms-of-service">terms of service</Link>.
        </p>

        <p style={{ marginTop: 28 }}>
          <Link to="/">← Back to the app</Link>
        </p>
      </article>
    </MarketingShell>
  );
}
